import AgentOutput from './AgentOutput';
import markdownit from 'markdown-it'
const md = markdownit()
const agentClass = "tbdc-agent-chat-agent";
const userClass = "tbdc-agent-chat-user";

export default class AgentItem {
    data: AgentOutput;
    message: string;
    isUser: boolean;
    className: string;
    filterText: string | null;

    constructor(data: AgentOutput, isUser: boolean, filterText: string | null = null) {
        this.data = data;
        this.isUser = isUser;
        this.filterText = filterText;
        if (!isUser) {
            this.message = md.render(data.message)
            this.className = agentClass;
        } else {
            this.message = data.message;
            this.className = userClass;
        }
    }
}